import React from "react";
import { cn } from "../../lib/utils.jsx";
import { useTransactions } from "../../hooks/useTransactions.tsx";
import { transactionTypes } from "../../data/transactionTypes.tsx";
import { categories } from "../../data/categories.tsx";

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function RecentTransactions() {
  const { transactions } = useTransactions();

  return (
    <div>
      <div className="widget-scroll">
        {transactions.map((tx, i) => {
          let transactionType = transactionTypes.find(
            (type) => type.id === tx.type
          );

          const categoryType = categories.find(
            (category) => category.id === tx.category
          );

          if (i > 4) {
            return null;
          }

          return (
            <div key={tx.id} className="flex items-center justify-between py-2">
              <div className="flex items-center gap-3">
                <div>
                  <p className="font-medium">{tx.title}</p>
                  <p className="text-sm text-gray-500">
                    {categoryType?.name} • {formatDate(tx.date)}
                  </p>
                </div>
              </div>

              <div className="text-right">
                <p className={cn("font-semibold", "text-gray-300")}>
                  {transactionType?.operator} {tx.currency}{" "}
                  {tx.amount.toLocaleString()}
                </p>
                <p className={cn("text-xs font-medium", "text-gray-300")}>
                  {transactionType?.name}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
